import AddIcon from "@mui/icons-material/Add";
import { IconButton } from "@mui/material";
import RemoveIcon from "@mui/icons-material/Remove";
import { View } from "../../../Base";
import { memo } from "react";

export const OverrideRowButtons = memo(
  ({
    showMinus = false,
    onMinusClick,
    disableMinus = false,
    showPlus = false,
    onPlusClick,
    disableAdd = false,
  }) => {
    return (
      <View>
        {showPlus && (
          <IconButton
            aria-label={"add"}
            size={"small"}
            onClick={() => onPlusClick && onPlusClick()}
            disabled={disableAdd}
          >
            <AddIcon />
          </IconButton>
        )}
        {showMinus && (
          <IconButton
            aria-label={"remove"}
            size={"small"}
            onClick={() => onMinusClick && onMinusClick()}
            disabled={disableMinus}
          >
            <RemoveIcon />
          </IconButton>
        )}
      </View>
    );
  }
);
